import classNames from "classnames";

function NavButton({ text, selected, onClick }) {
  return (
    <div
      className={classNames("mx-1.5 cursor-pointer h-max pl-nav-button", {
        "pl-nav-button-selected": selected,
        "pl-nav-button-unselected": !selected,
      })}
      datatext={text}
      onClick={onClick}
    >
      {text}
      <hr />
    </div>
  );
}

export default NavButton;
